var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "date-piker" },
      [
        _c(
          "money",
          _vm._b(
            {
              attrs: {
                rounded: "",
                dense: "",
                outlined: "",
                disabled: _vm.disabled,
                rules: [
                  function(v) {
                    return !!v || "Campo obrigatório"
                  }
                ]
              },
              nativeOn: {
                keyup: function($event) {
                  return _vm.change.apply(null, arguments)
                }
              },
              model: {
                value: _vm.data,
                callback: function($$v) {
                  _vm.data = $$v
                },
                expression: "data"
              }
            },
            "money",
            _vm.money,
            false
          )
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }